import { favoritesEditFolderRule, favoritesRearrangeItemsRule } from './favoritesCalloutRules';

const editFolderConfig = {
    name: 'favoritesEditFolder',
    priority: 400,
    rule: favoritesEditFolderRule,
    action: () => dispatch =>
        dispatch({
            type: 'SHOW_FAVORITES_FOLDER_CALLOUT',
        }),
};

const rearrangeItemsConfig = {
    name: 'favoritesRearrangeItems',
    priority: 405,
    rule: favoritesRearrangeItemsRule,
    action: () => dispatch =>
        dispatch({
            type: 'SHOW_FAVORITES_REARRANGE_ITEMS_CALLOUT',
        }),
};

export const favoritesCallouts = [editFolderConfig, rearrangeItemsConfig];
